// extracted by mini-css-extract-plugin
export default {"root":"ScheduleHeader_root__h2PdP","titleDefault":"ScheduleHeader_titleDefault__6Bzwd","titleToday":"ScheduleHeader_titleToday__yQtjH","descr":"ScheduleHeader_descr__iuO5A"};